import { Injectable } from '@angular/core';
import { IEquity, IFreeTable, INotesComponent, INotesSection, Notes } from '@modeso/types__aumico-lib-annualreport-be';
import { ComponentType } from '@modeso/types__aumico-lib-notes-be';
import { I18NextService } from 'angular-i18next';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class MockNotesAccordionDataHelper {
    mockAccordions(newAccordions: INotesSection[], localizedTexts: I18NextService): INotesSection[] {
        const mockedAccordionData: INotesSection[] = [];

        newAccordions.forEach((accordion: INotesSection) => {
            const mockedAccordion = { ...accordion };
            mockedAccordion.data = this.mockAccordion(accordion.data, localizedTexts);
            mockedAccordionData.push(mockedAccordion);
        });

        return mockedAccordionData;
    }

    private mockAccordion(newAccordionData: INotesComponent[], localizedTexts: I18NextService): INotesComponent[] {
        const mockedAccordionData: INotesComponent[] = [];
        newAccordionData.forEach((accordion: INotesComponent, index: number) => {
            const componentName = accordion.componentName;
            const newData: Notes = accordion.data;

            const mockedData: Notes = this.mockComponent(componentName, newData, localizedTexts);
            mockedAccordionData.push({
                componentName,
                data: mockedData,
                componentId: `${componentName}_${index}`,
                hasFootnotes: false,
            });
        });

        return mockedAccordionData;
    }

    private mockComponent(
        componentName: ComponentType,
        newComponentData: Notes,
        localizedTexts: I18NextService,
    ): Notes {
        switch (componentName) {
            case ComponentType.EQUITY:
                const mockedEquityComponent = cloneDeep<IEquity>(newComponentData as IEquity);
                if (mockedEquityComponent.options.totalRow) {
                    mockedEquityComponent.totalRow = {
                        text: localizedTexts.t('aumico_notes_table_with_form_total') as string,
                        currentValue1: 0,
                        previousValue1: 0,
                        currentValue2: 0,
                        previousValue2: 0,
                    };
                }
                mockedEquityComponent.rows.push({
                    text: null,
                    currentValue1: null,
                    previousValue1: null,
                    currentValue2: null,
                    previousValue2: null,
                } as any);

                return mockedEquityComponent;

            case ComponentType.FREE_TABLE_WITH_AMOUNTS:
                const mockedFreeTableComponent = cloneDeep<IFreeTable>(newComponentData as IFreeTable);
                if (mockedFreeTableComponent.options.totalRow) {
                    mockedFreeTableComponent.totalRow = {
                        text: localizedTexts.t('aumico_notes_table_with_form_total') as string,
                        currentValue: 0,
                        previousValue: 0,
                    };
                }
                mockedFreeTableComponent.rows.push({
                    text: null,
                    currentValue: null,
                    previousValue: null,
                } as any);

                return mockedFreeTableComponent;

            default:
                return newComponentData;
        }
    }
}
